const action = {
    general: '运行流程扩展时发生错误，请稍后重试。',
    sign_in_identifier_changed: '流程扩展不能更改本次验证使用的登录标识。',
};
export default Object.freeze(action);
